module.exports = __webpack_public_path__ + "static/media/12_3.1f2b01ac.jpg";